/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class videoPreviewController {
    // @ngInject
    constructor($scope, $state, $rootScope, $sce, localStorageService, filePreviewAvailable, authService, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let plan = localStorageService.get("currentPlan")
        let authoring = localStorageService.get("authoringData")
        let resourceId = $state.params.resourceId;

        $scope.toogleResource = "Show Details";
        var screenLen = screen.width;
        if (screenLen < 1281) {
            $scope.isShow = false;
        } else {
            $scope.isShow = true;
        }

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })

                if ($scope.userPrev.preview && $scope.userPrev.preview.read && ($scope.userPrev.uploadVideo == undefined || ($scope.userPrev.uploadVideo && !$scope.userPrev.uploadVideo.create)) && ($scope.userPrev.approve == undefined || ($scope.userPrev.approve && !$scope.userPrev.approve.create))) {
                    try {
                        var data = {
                            resource: {
                                type: $scope.resource.type,
                                subject_id: authoring.subject_id,
                                class_id: authoring.class_id,
                                curriculum_id: authoring.curriculum_id,
                                batch_id: authoring.batch_id,
                                session_id: authoring.session_id,
                                school_id: authoring.school_id,
                                theme_id: plan.theme_id,
                                plan_id: planId,
                                progress_data: {
                                    _id: resourceId,
                                    title: $scope.resource.title
                                }
                            },
                            user_id: userId
                        }
                        authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, () => {})
                    } catch (ex) {}
                }
                if ($scope.resource) {
                    if ($scope.resource.url) {
                        $scope.isAvailable = true
                        filePreviewAvailable.filePreviewUrl('local', $scope.resource.url, function(response) {
                            $scope.fileAvaliable = response.fileAvaliable
                            if (response.fileAvaliable) {
                                $scope.src = $sce.trustAsResourceUrl(response.fileUrl)
                                _.defer(() => {
                                    $scope.$apply();
                                });
                            }
                        })
                    }
                }
            }
        }
        /*UserPrivilages.getUserPrivilageInitialSetting(function() {
            let userAccess = UserPrivilages.getFeatures('video');
            $scope.userPrev = {};
            if (userAccess.length > 0) {
                _.each(userAccess, function(obj) {
                    let user_access = {};
                    _.each(obj.privilege, function(privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    $scope.userPrev[obj.feature_id] = user_access;
                })
            }
            loadTemplate()
        })*/

        /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "video"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }
    }
}

export default videoPreviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/videoPreview.js